// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BrowserUtils } from './UtilsClasses/BrowserUtils';
class _ErrorInformationStorage {
    constructor() {
        this.Storage = [];
        this.FilterStorageObj = {}; // для фильтрации
        this.w_BWD = null;
        this.DCache = null;
        this.msgType = 'error report';
        this.SetBuildVersion = (buildVersion) => {
            this.w_BWD = buildVersion;
            if (!buildVersion) {
                return;
            }
            this.buildVersion = this.w_BWD.version + '.' + this.w_BWD.build + '.' + this.w_BWD.build_version;
            if (this.w_BWD.developer_version && this.w_BWD.developer_version !== '0') {
                this.buildVersion += '-' + this.w_BWD.developer_version;
            }
        };
        this.timer = 5 * 60 * 1000;
        this.versionBr = BrowserUtils.getBrowserVersion();
    }
    GetException(ex) {
        if (ex.message in this.FilterStorageObj) {
            return;
        }
        this.DCache.HandleException(ex);
        const timestamp = new Date();
        const item = {
            msgType: this.msgType,
            timestamp,
            content: {
                version: 'Build version: ' + this.buildVersion + ' Browser: ' + this.versionBr,
                code: ex.message,
                header: ex.name,
                msgBody: ex.stack
            }
        };
        this.FilterStorageObj[ex.message] = ex.message;
        this.Storage.push(item);
        if (!this.id) {
            this.id = setInterval(this.SendStorage.bind(this), this.timer, this.Storage);
        }
    }
    SendStorage(Storage) {
        const kakxochesh = Storage;
        this.DCache.SendInformationMessage(kakxochesh);
        kakxochesh.length = 0;
    }
    SetDataCache(dataCache) {
        this.DCache = dataCache;
    }
    SetTimerValue(timeMinut) {
        this.timer = timeMinut * 60 * 1000;
    }
}
export class CustomErrorClass {
    constructor(mess, name, stack) {
        this.message = mess;
        this.name = name;
        this.stack = stack;
    }
}
export const ErrorInformationStorage = new _ErrorInformationStorage();
